import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Form from '~~elements/Form';
import { parseStaffsData } from '../service';
import Column from './Column';

const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .description {
    margin: 2rem 0;
    white-space: pre-line;
    letter-spacing: 2px;
    fint-size: 0.9rem;
    text-align: start;
  }

  input:disabled {
    opacity: 0.8;
  }
`;

const StaffDiv = styled.div`
  width: 100%;
  border: 1px solid black;
  border-radius: 5px;
  padding: 1rem;
  margin: 0.5rem 0;
  position: relative;
  .staff-title {
    padding: 0 0 0.5rem 0;
    margin: 0 0.5rem 0.5rem;
    border-bottom: 1px solid gray;
  }
`;

const StaffsSection = ({ teamInRegistry, registry, onChange, apiInProgress }) => {
  const [currentStaffsData, setCurrentStaffsData] = useState(parseStaffsData(teamInRegistry, registry));

  useEffect(() => {
    setCurrentStaffsData(parseStaffsData(teamInRegistry, registry));
  }, [registry, teamInRegistry]);

  useEffect(() => {
    const originStaffsData = JSON.stringify(parseStaffsData(teamInRegistry, registry));
    if (originStaffsData === JSON.stringify(currentStaffsData)) {
      onChange(null);
      return;
    }

    onChange(currentStaffsData);
    return;
  }, [currentStaffsData, onChange, registry, teamInRegistry]);

  const handleColumnOnChange = (staffIndex, columnIndex) => (data) => {
    currentStaffsData.staffs[staffIndex].columns[columnIndex] = {
      ...currentStaffsData.staffs[staffIndex].columns[columnIndex],
      value: data.value,
      url: data.url,
    };

    const removeImagePaths = [...currentStaffsData.remove_image_paths];
    if (data.removedImage) {
      removeImagePaths.push(data.removedImage);
    }

    setCurrentStaffsData({
      ...currentStaffsData,
      remove_image_paths: [...removeImagePaths],
    });
  };

  return (
    <StyledDiv>
      <Form onSubmit={(e) => e.preventDefault()} className="lg">
        <div className="box">
          {currentStaffsData.staffs.map((staff, staffIndex) => (
            <StaffDiv key={staffIndex}>
              <div className="staff-title">
                <label>
                  {staff.title}
                  {staff.is_required && <i>*</i>}
                </label>
              </div>
              <div className="input-field lg">
                <div className="input-list">
                  {staff.columns.map((column, index) => (
                    <Column
                      key={index}
                      column={column}
                      onChange={handleColumnOnChange(staffIndex, index)}
                      apiInProgress={apiInProgress}
                    />
                  ))}
                </div>
              </div>
            </StaffDiv>
          ))}
        </div>
      </Form>
    </StyledDiv>
  );
};

export default StaffsSection;
